import styled from 'styled-components';
import { Palette } from 'config';

export const InputWrapper = styled.div`
  display: flex;
  gap: 10px;
  background: white;
  svg {
    fill: ${Palette.Primary._500};
  }
  margin-bottom: 8px;
`;

export const IconWrapp = styled.div`
  display: flex;
  flex-basis: 1%;
`;
